/* eslint-disable */
// import React, { useEffect, useState, useRef } from 'react';
// import { shallowEqual, useDispatch, useSelector } from 'react-redux';
// import { getAllQualificationTypesCombo, getQualificationNamesOfATypeCombo, getQualSubjectTypeListPagination, manageQaulSubjects, resetQaulificationSubject, resetQaulificationSubjectList } from '../actions/masterManagementAction';
// import masterLabels from '../labels/master_en.json';
// import commonLabels from '../../../common/labels/common_en.json';
// import TablePagination from '../../../common/components/TablePagination';
// import ConfirmationDialog from '../../../common/components/ConfirmationDialog';
// import QualificationSubjectForm from './QualificationSubjectForm';
// import { toastr } from 'react-redux-toastr';
// import Select from 'react-select';
// const QualificationSubjectList = () => {
//   let rowPerPage = 10;
//   const dispatch = useDispatch();
//   let [addSubject, setAddSubject] = useState({ "Mode": false, "qualificationTypeCode": false, "qualificationNameCode": false });
//   let [searchMode, setSearchMode] = useState(false);
//   let [textToSearch, setTextToSearch] = useState(false);
//   let [qualificationTypeCode, setQualificationTypeCode] = useState(false);
//   let [qualificationNameCode, setQualificationNameCode] = useState(false);
//   let [listCurrentPage, setListCurrentPage] = useState(0);
//   let [showModal, setShowModal] = useState(false);
//   let [deleteSubject, setDeleteSubject] = useState(0);

//   useEffect(() => {
//     dispatch(getAllQualificationTypesCombo());
//     dispatch(resetQaulificationSubject());
//     dispatch(resetQaulificationSubjectList());
//     setTextToSearch(false);
//     setQualificationNameCode(false);
//     // eslint-disable-next-line
//   }, [])

//   const inputRef = useRef();

//   const onQualificationTypeChange = (e) => {
//     dispatch(resetQaulificationSubject());
//     dispatch(resetQaulificationSubjectList());

//     setTextToSearch(false);
//     setQualificationNameCode(false);

//     let qualificationSelectedTypeCode = e.target.value;
//     setQualificationTypeCode(qualificationSelectedTypeCode);
//     dispatch(getQualificationNamesOfATypeCombo(qualificationSelectedTypeCode));
//   }

//   const onQualificationNameChange = (e) => {
//     setTextToSearch(false);
//     let qualificationSelectedNameCode = e.target.value;
//     setQualificationNameCode(qualificationSelectedNameCode);
//     qualificationTypeCode && dispatch(getQualSubjectTypeListPagination(0, rowPerPage, qualificationSelectedNameCode, textToSearch));
//   }

//   const searchData = (textToSearch) => {
//     setSearchMode(Number(new Date()));
//     qualificationTypeCode && qualificationNameCode && dispatch(getQualSubjectTypeListPagination(0, rowPerPage, qualificationNameCode, textToSearch));
//     (!qualificationTypeCode || !qualificationNameCode) && toastr.error(commonLabels.SEARCH_VALIDATION_ERROR);
//   }

//   const { qualificationTypesCombo, qualificationNamesCombo, qualificationSubjectNames, qualificationSubjectPageNoCounter } = useSelector((state) => state.masterManagementReducer, shallowEqual);

//   let tableCounter = qualificationSubjectPageNoCounter + 1;

//   const manageSubject = (id) => {
//     setShowModal(true);
//     setDeleteSubject(id);
//   }

//   const deleteQualSubject = (id) => {
//     setShowModal(false);
//     let requestBody = { "id": id, "isDeleted": true };
//     dispatch(manageQaulSubjects(requestBody, rowPerPage, listCurrentPage, qualificationNameCode, textToSearch));
//   }

//   const activeQualSubject = (id, isActive) => {
//     let requestBody = { "id": id, "isActive": !isActive };
//     dispatch(manageQaulSubjects(requestBody, rowPerPage, listCurrentPage, qualificationNameCode, textToSearch));
//   }


//   const qualificationOptions = qualificationNamesCombo
//     ?.filter(element => !element.isDeleted)
//     .map(element => ({
//       value: element.qualificationNameCode,
//       label: element.qualificationName
//     }));

//   return addSubject.Mode != false ? (
//     <div>
//       <QualificationSubjectForm
//         addSubject={addSubject}
//         setAddSubject={setAddSubject}
//         setQualificationTypeCode={setQualificationTypeCode}
//         qualificationNameCode={qualificationNameCode}
//         setQualificationNameCode={setQualificationNameCode}
//         setTextToSearch={setTextToSearch}
//       />
//     </div>
//   ) : (
//     <div className="border border-light" style={{ width: "100%", padding: "20px" }}>
//       <div className='form-group'>
//         <div className='row'>
//           <div className='col-md-2  '>
//             <label className="font-weight-bold float-left">{masterLabels.qualificationSubjectList.Dropdown_Qualification_Type}<span className="redColor">*</span></label>
//             <select
//               className='form-select mt-1'
//               name="qualificationType"
//               onInput={onQualificationTypeChange}
//               ref={inputRef}
//               defaultValue={addSubject && addSubject.qualificationTypeCode}
//             >
//               <option key={0} value="">{commonLabels.COMBO_SELECT}</option>
//               {qualificationTypesCombo && qualificationTypesCombo.length > 0 && qualificationTypesCombo.filter(element => element.isDeleted == false).map((element, index) =>
//                 <option key={index} value={element.qualificationtypecode}>{element.qualificationtypename}</option>
//               )}
//             </select>
//           </div>
//           <div className='col-md-3  '>
//             <label className="font-weight-bold float-left">{masterLabels.qualificationSubjectList.Dropdown_Qualification_Name}<span className="redColor">*</span></label><br />
//             {/* <select
//               className='form-select mt-1'
//               name="qualificationName"
//               onInput={onQualificationNameChange}
//               ref={inputRef}
//               value={qualificationNameCode}
//               defaultValue={addSubject && addSubject.qualificationNameCode}
//             >
//               <option key={0} value="">{commonLabels.COMBO_SELECT}</option>
//               {qualificationNamesCombo && qualificationNamesCombo.length > 0 && qualificationNamesCombo && qualificationNamesCombo.filter(element => element.isDeleted == false).map((element, index) =>
//                 <option key={index} value={element.qualificationNameCode}>{element.qualificationName}</option>
//               )}
//             </select> */}
//             <Select
//               className="mt-1"
//               name="qualificationName"
//               options={qualificationOptions}
//               onChange={selectedOption => {
//                 onQualificationNameChange({ target: { name: 'qualificationName', value: selectedOption?.value } });
//               }}
//               value={qualificationOptions?.find(option => option.value === qualificationNameCode)}
//               placeholder={commonLabels.COMBO_SELECT}
//               isClearable
//               ref={inputRef}
//             />
//           </div>
//           <div className='col-md-3 mt-3'>
//             <input
//               type="text"
//               className="form-control mt-2"
//               name="textToSearch"
//               value={textToSearch == false ? "" : textToSearch}
//               placeholder={masterLabels.qualificationSubjectList.Text_To_Search_Label}
//               onChange={event => { setTextToSearch(event.target.value); setSearchMode(false); }}
//               maxLength="50"
//             />
//           </div>
//           <div className='col-md-1  mt-3'>
//             <button className='form-control mt-2 btn-primary button_search' onClick={() => { searchData(textToSearch); }}><i className="fa fa-search" type="button" ></i></button>
//           </div>
//           <div className='col-md-1'></div>
//           <div className='col-md-2 text-right mt-4'>
//             <button className=" btn form-control btn-primary custom_button" onClick={() => { setAddSubject({ "Mode": "Add" }) }}>
//               {masterLabels.qualificationSubjectList.Add_New_Sub_Btn}
//             </button>
//           </div>
//         </div>
//       </div>
//       <br />
//       <div className='form-group'>
//         {qualificationSubjectNames && qualificationSubjectNames.totalNoOfRecords > 0 ?
//           <div className='row'>
//             <div className='col-md-12'>
//               <table className="table table-bordered">
//                 <thead className="thead-light">
//                   <tr>
//                     <th scope="col" className='w-10 text-center'>{masterLabels.documentTypeList.Tbl_ID_Col}</th>
//                     <th scope="col" className='w-20 text-center'>{masterLabels.documentTypeList.SUBJECT_ID}</th>
//                     <th scope="col" className='w-50 text-left'>{masterLabels.qualificationSubjectList.Tbl_Name_Col}</th>
//                     {/* <th scope="col" className='w-40 text-left'>{masterLabels.qualificationSubjectList.Tbl_Name_Marathi_Col}</th> */}
//                     <th scope="col" className='w-10 text-center'>{masterLabels.qualificationSubjectList.Tbl_Action_Col}</th>
//                   </tr>
//                 </thead>
//                 <tbody className='small'>
//                   {qualificationSubjectNames.subjectList && qualificationSubjectNames.subjectList.map((element, index) => {
//                     if (element) {
//                       return (
//                         <tr key={index}>
//                           <td className="w-10 word-break text-center">{element.id}</td>
//                           <td className="w-10 word-break text-center">{element.subjectId}</td>
//                           <td className="word-break text-left">{element.subjectName}</td>
//                           {/* <td className="text-left">{element.translations}</td> */}
//                           <td className="w-10 word-break text-center">
//                             <i role="button" data-toggle="tooltip" title={commonLabels.BUTTON_EDIT} className='text-primary fa fa-edit' onClick={() => { setAddSubject({ "Mode": "Edit", "id": element.id, "qualificationTypeCode": qualificationTypeCode, "qualificationNameCode": qualificationNameCode }); }}></i>
//                             &nbsp;&nbsp;
//                             <i role="button" data-toggle="tooltip" title={element.isActive ? commonLabels.BUTTON_INACTIVE : commonLabels.BUTTON_ACTIVE}
//                               className={element.isActive === true ? "text-success fa fa-toggle-on" : "text-danger fa fa-toggle-off"} onClick={(e) => { activeQualSubject(element.id, element.isActive); }}></i>
//                             &nbsp;&nbsp;
//                             <i role="button" data-toggle="tooltip" title={commonLabels.BUTTON_DELETE} className='text-danger fa fa-trash' onClick={(e) => { manageSubject(element.id); }}></i>
//                           </td>
//                         </tr>
//                       )
//                     }
//                   })
//                   }
//                 </tbody>
//               </table>
//               {qualificationTypeCode && qualificationNameCode &&
//                 <TablePagination
//                   paginationFor="qualification_subject_list"
//                   rowPerPage={rowPerPage}
//                   setListCurrentPage={setListCurrentPage}
//                   searchCode2={qualificationNameCode}
//                   textToSearch={textToSearch}
//                   searchMode={searchMode}
//                   totalCount={qualificationSubjectNames.totalNoOfRecords}
//                 />
//               }
//             </div></div>
//           :
//           <div className='text-center'>
//             <font className="text-danger">{qualificationTypeCode && qualificationNameCode && commonLabels.NO_DATA_FOUND}
//             </font>
//           </div>}
//       </div>

//       {
//         <ConfirmationDialog
//           showModal={showModal}
//           Title={commonLabels.CONFIRMATION_MODAL_TITLE}
//           Message={commonLabels.CONFIRMATION_MESSAGE}
//           setShowModal={setShowModal}
//           deleteRecord={deleteQualSubject}
//           deletedId={deleteSubject}
//           IsConfirmation={"true"}
//         />
//       }
//     </div>
//   );
// }

// export default QualificationSubjectList;


import React, { useEffect, useRef, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import Select from 'react-select';
import ConfirmationDialog from '../../../common/components/ConfirmationDialog';
import TablePagination from '../../../common/components/TablePagination';
import commonLabels from '../../../common/labels/common_en.json';
import { getAllQualificationTypesCombo, getQualificationNamesOfATypeCombo, getQualSubjectTypeListPagination, manageQaulSubjects, resetQaulificationSubject, resetQaulificationSubjectList } from '../actions/masterManagementAction';
import masterLabels from '../labels/master_en.json';
import QualificationSubjectForm from './QualificationSubjectForm';
const QualificationSubjectList = ({selectedQualificationType,selectedQualificationCode}) => {
  let rowPerPage = 10;
  const dispatch = useDispatch();
  let [addSubject, setAddSubject] = useState({ "Mode": false, "qualificationTypeCode": false, "qualificationNameCode": false });
  let [searchMode, setSearchMode] = useState(false);
  let [textToSearch, setTextToSearch] = useState(false);
  let [qualificationTypeCode, setQualificationTypeCode] = useState(false);
  let [qualificationNameCode, setQualificationNameCode] = useState(false);
  let [listCurrentPage, setListCurrentPage] = useState(0);
  let [showModal, setShowModal] = useState(false);
  let [deleteSubject, setDeleteSubject] = useState(0);

  useEffect(() => {
    dispatch(getAllQualificationTypesCombo());
    dispatch(resetQaulificationSubject());
    dispatch(resetQaulificationSubjectList());
    setTextToSearch(false);
    setQualificationNameCode(false);
    dispatch(getQualSubjectTypeListPagination(0, rowPerPage));

    // eslint-disable-next-line
  }, [])

  const inputRef = useRef();

  const onQualificationTypeChange = (e) => {
    dispatch(resetQaulificationSubject());
    dispatch(resetQaulificationSubjectList());

    setTextToSearch(false);
    setQualificationNameCode(false);

    let qualificationSelectedTypeCode = e.target.value;
    setQualificationTypeCode(qualificationSelectedTypeCode);
    dispatch(getQualificationNamesOfATypeCombo(qualificationSelectedTypeCode));
  }

  const onQualificationNameChange = (e) => {
    setTextToSearch(false);
    let qualificationSelectedNameCode = e.target.value;
    setQualificationNameCode(qualificationSelectedNameCode);
    qualificationTypeCode && dispatch(getQualSubjectTypeListPagination(0, rowPerPage, qualificationNameCode, textToSearch));
  }

  const searchData = (textToSearch) => {
    setSearchMode(Number(new Date()));
    qualificationTypeCode && qualificationNameCode && dispatch(getQualSubjectTypeListPagination(0, rowPerPage, qualificationNameCode, textToSearch));
    (!qualificationTypeCode || !qualificationNameCode) && toastr.error(commonLabels.SEARCH_VALIDATION_ERROR);
  }

  const { qualificationTypesCombo, qualificationNamesCombo, qualificationSubjectNames, qualificationSubjectPageNoCounter } = useSelector((state) => state.masterManagementReducer, shallowEqual);

  let tableCounter = qualificationSubjectPageNoCounter + 1;

  const manageSubject = (id) => {
    setShowModal(true);
    setDeleteSubject(id);
  }

  const deleteQualSubject = (id) => {
    setShowModal(false);
    let requestBody = { "id": id, "isDeleted": true };
    dispatch(manageQaulSubjects(requestBody, rowPerPage, listCurrentPage, qualificationNameCode, textToSearch));
  }

  const activeQualSubject = (id, isActive) => {
    let requestBody = { "id": id, "isActive": !isActive };
    dispatch(manageQaulSubjects(requestBody, rowPerPage, listCurrentPage, qualificationNameCode, textToSearch));
  }

  const qualificationOptions = Array.isArray(qualificationNamesCombo) && qualificationNamesCombo?.filter(element => !element.isDeleted).slice()
    .sort((a, b) => a.qualificationName.localeCompare(b.qualificationName)).map(element => ({
      value: element.qualificationNameCode,
      label: element.qualificationName
    }));

  return addSubject.Mode != false ? (
    <div>
      <QualificationSubjectForm
        addSubject={addSubject}
        setAddSubject={setAddSubject}
        setQualificationTypeCode={setQualificationTypeCode}
        qualificationNameCode={qualificationNameCode}
        setQualificationNameCode={setQualificationNameCode}
        setTextToSearch={setTextToSearch}
        rowPerPage={rowPerPage}
        qualificationSubjectNames={qualificationSubjectNames}
      />
    </div>
  ) : (
    <div className="border border-light" style={{ width: "100%", padding: "20px" }}>
      <div className='form-group'>
        <div className='row'>
          <div className='col-md-2  '>
            <label className="font-weight-bold float-left">{masterLabels.qualificationSubjectList.Dropdown_Qualification_Type}<span className="redColor">*</span></label>
            <select
              className='form-select mt-1'
              name="qualificationType"
              onInput={onQualificationTypeChange}
              ref={inputRef}
              defaultValue={addSubject && addSubject.qualificationTypeCode}
            >
              <option key={0} value="">{commonLabels.COMBO_SELECT}</option>
              {qualificationTypesCombo && qualificationTypesCombo.length > 0 && qualificationTypesCombo.filter(element => element.isDeleted == false).map((element, index) =>
                <option key={index} value={element.qualificationtypecode}>{element.qualificationtypename}</option>
              )}
            </select>
          </div>
          <div className='col-md-3  '>
            <label className="font-weight-bold float-left">{masterLabels.qualificationSubjectList.Dropdown_Qualification_Name}<span className="redColor">*</span></label><br />
            {/* <select
              className='form-select mt-1'
              name="qualificationName"
              onInput={onQualificationNameChange}
              ref={inputRef}
              value={qualificationNameCode}
              defaultValue={addSubject && addSubject.qualificationNameCode}
            >
              <option key={0} value="">{commonLabels.COMBO_SELECT}</option>
              {qualificationNamesCombo && qualificationNamesCombo.length > 0 && qualificationNamesCombo && qualificationNamesCombo.filter(element => element.isDeleted == false).map((element, index) =>
                <option key={index} value={element.qualificationNameCode}>{element.qualificationName}</option>
              )}
            </select> */}
            <Select
              className="mt-1"
              name="qualificationName"
              options={qualificationOptions}
              onChange={selectedOption => {
                onQualificationNameChange({ target: { name: 'qualificationName', value: selectedOption?.value } });
              }}
              value={
                qualificationOptions && qualificationOptions?.find(option => option.value === qualificationNameCode) || null
              }
              placeholder={commonLabels.COMBO_SELECT}
              isClearable
              ref={inputRef}
            />
          </div>
          <div className='col-md-3 mt-3'>
            <input
              type="text"
              className="form-control mt-2"
              name="textToSearch"
              value={textToSearch == false ? "" : textToSearch}
              placeholder={masterLabels.qualificationSubjectList.Text_To_Search_Label}
              onChange={event => { setTextToSearch(event.target.value); setSearchMode(false); }}
              maxLength="50"
            />
          </div>
          <div className='col-md-1  mt-3'>
            <button className='form-control mt-2 btn-primary button_search' onClick={() => { searchData(textToSearch); }}><i className="fa fa-search" type="button" ></i></button>
          </div>
          <div className='col-md-1'></div>
          <div className='col-md-2 text-right mt-4'>
            <button className=" btn form-control btn-primary custom_button" onClick={() => { setAddSubject({ "Mode": "Add" }) }}>
              {masterLabels.qualificationSubjectList.Add_New_Sub_Btn}
            </button>
          </div>
        </div>
      </div>
      <br />
      <div className='form-group'>
        {qualificationSubjectNames && qualificationSubjectNames.totalNoOfRecords > 0 ?
          <div className='row'>
            <div className='col-md-12'>
              <table className="table table-bordered">
                <thead className="thead-light">
                  <tr>
                    <th scope="col" className='w-10 text-center'>{masterLabels.documentTypeList.Tbl_ID_Col}</th>
                    <th scope="col" className='w-20 text-center'>{masterLabels.documentTypeList.SUBJECT_ID}</th>
                    <th scope="col" className='w-50 text-left'>{masterLabels.qualificationSubjectList.Tbl_Name_Col}</th>
                    {/* <th scope="col" className='w-40 text-left'>{masterLabels.qualificationSubjectList.Tbl_Name_Marathi_Col}</th> */}
                    <th scope="col" className='w-10 text-center'>{masterLabels.qualificationSubjectList.Tbl_Action_Col}</th>
                  </tr>
                </thead>
                <tbody className='small'>
                  {qualificationSubjectNames.subjectList && qualificationSubjectNames.subjectList.map((element, index) => {
                    if (element) {
                      return (
                        <tr key={index}>
                          <td className="w-10 word-break text-center">{element.id}</td>
                          <td className="w-10 word-break text-center">{element.subjectId}</td>
                          <td className="word-break text-left">{element.subjectName}</td>
                          {/* <td className="text-left">{element.translations}</td> */}
                          <td className="w-10 word-break text-center">
                            <i role="button" data-toggle="tooltip" title={commonLabels.BUTTON_EDIT} className='text-primary fa fa-edit' onClick={() => { setAddSubject({ "Mode": "Edit", "id": element.id, "qualificationTypeCode": qualificationTypeCode, "qualificationNameCode": qualificationNameCode }); }}></i>
                            &nbsp;&nbsp;
                            <i role="button" data-toggle="tooltip" title={element.isActive ? commonLabels.BUTTON_INACTIVE : commonLabels.BUTTON_ACTIVE}
                              className={element.isActive === true ? "text-success fa fa-toggle-on" : "text-danger fa fa-toggle-off"} onClick={(e) => { activeQualSubject(element.id, element.isActive); }}></i>
                            &nbsp;&nbsp;
                            <i role="button" data-toggle="tooltip" title={commonLabels.BUTTON_DELETE} className='text-danger fa fa-trash' onClick={(e) => { manageSubject(element.id); }}></i>
                          </td>
                        </tr>
                      )
                    }
                  })
                  }
                </tbody>
              </table>
              {
                <TablePagination
                  paginationFor="qualification_subject_list"
                  rowPerPage={rowPerPage}
                  setListCurrentPage={setListCurrentPage}
                  searchCode2={qualificationNameCode}
                  textToSearch={textToSearch}
                  searchMode={searchMode}
                  totalCount={qualificationSubjectNames.totalNoOfRecords}
                />
              }
            </div></div>
          :
          <div className='text-center'>
            <font className="text-danger">{qualificationTypeCode && qualificationNameCode && commonLabels.NO_DATA_FOUND}
            </font>
          </div>}
      </div>

      {
        <ConfirmationDialog
          showModal={showModal}
          Title={commonLabels.CONFIRMATION_MODAL_TITLE}
          Message={commonLabels.CONFIRMATION_MESSAGE}
          setShowModal={setShowModal}
          deleteRecord={deleteQualSubject}
          deletedId={deleteSubject}
          IsConfirmation={"true"}
        />
      }
    </div>
  );
}

export default QualificationSubjectList;